export const genieStyles = {
  computeDetailsIcon: {
    fontSize: '16px',
  },
};
